export const grades = [
  {
    courseCode: "CSCI-5",
    courseName: "Computer Science I",
    grade: "A",
    gradePoints: 4.0,
    totalPoints: 4.0,
    score: 94.0,
  },
  {
    courseCode: "CSCI-6",
    courseName: "Computer Science II",
    grade: "B",
    gradePoints: 3.5,
    totalPoints: 4.0,
    score: 85.0,
  },
  {
    courseCode: "MATH-1",
    courseName: "Mathematics I",
    grade: "C",
    gradePoints: 3.0,
    totalPoints: 4.0,
    score: 75.0,
  },
  {
    courseCode: "MATH-2",
    courseName: "Statistics",
    grade: "B",
    gradePoints: 3.5,
    totalPoints: 4.0,
    score: 87.0,
  },
];
